import WorkshopCalendar from "./WorkshopCalendar";
import InfoRegisterPlate from "../InfoRegisterPlate";
import { useSelector } from "react-redux";
import { altChooseButtonStyleTurquoise } from "../../../../shared/styles/buttonStyles";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import InfoForNext from "../InfoForNext";
import SelectedVehicle from "../../../../shared/components/SelectedVehicle";
import SelectedServices from "./SelectedServices";
import { boxStyleHighlighted } from "../../../../shared/styles/boxStyles";
import { highlLightedTextStyle } from "../../../../shared/styles/typographStyles";
import { useWindowSize } from "../../../../shared/hooks/useWindowSize";

export default function BookStep1() {

    const draft = useSelector((state) => state.reservation.draft);
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { isMobile } = useWindowSize();

    // const [ allSelected, setAllSelected ] = useState(false);

    // useEffect(() => {
    //     if (draft.car && draft.date && draft.services && draft.services.length > 0) {
    //         setAllSelected(true);
    //     } else {
    //         setAllSelected(false);
    //     }
    // }, [draft]);

    const toNextStep = () => {
        const params = new URLSearchParams(location.search);
        params.set('step', '2');
        navigate(`/workshops/${draft.workshop.id}?${params.toString()}`);
    };

    const allSelected = draft.car && draft.date && draft.services && draft.services.length > 0;

    return (
        <Box className='workshop-page_steps'>
            <WorkshopCalendar />
            { draft.car == null && <InfoRegisterPlate /> }
            {/* <RegisterPlate /> */}
            <SelectedVehicle canEdit={true}/>
            <SelectedServices draft={draft} />
            {/* <BaseServices category="maintenance" /> */}
            {/* { draft.car && <Car /> } */}
            {!allSelected && <InfoForNext />}
            <Box
                sx={{...boxStyleHighlighted}}
            >
                <Typography 
                    variant="body1" 
                    sx={{...highlLightedTextStyle}}
                >
                    {t('actions.nextStepInfo')}
                </Typography>
                <Button
                    variant="contained" 
                    sx={{...altChooseButtonStyleTurquoise, width: isMobile ? '100%' : '200px'}}
                    disabled={!allSelected}
                    onClick={toNextStep}
                >
                    {t('actions.next')}
                </Button>
            </Box>
        </Box>
    );
}